import { Exception } from '@/types';

export class Result {

    public success: boolean;
    public error?: string;
    public message?: string;

    constructor(success: boolean, exception?: Exception) {
        this.success = success;
        if (exception) {
            this.error = exception.error;
            this.message = exception.message;
        } else if (!success) {
            this.error = '';
            this.message = '';
        }
    }
}